import type {
  DayDepthChartWidgetEntity,
  TDayDepthSerializedInternalState,
} from 'src/pages/dashboard/features/well-day-depth-widget/DayDepthChartWidget.entity';
import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

export function serializeDayDepthChartTemplate(widget: DayDepthChartWidgetEntity): TSerializedWidgetTemplate {
  const internalState: TDayDepthSerializedInternalState = {
    wellId: null,
    stateParams: {
      timeZone: widget.stateParams.timeZone,
      legendVisible: widget.stateParams.legendVisible,
      autoScroll: widget.stateParams.autoScroll,
      infoPanels: widget.stateParams.infoPanels,
      offsetX: widget.stateParams.offsetX,
      offsetY: widget.stateParams.offsetY,
      zoomTime: widget.stateParams.zoomTime,
      zoomDepth: widget.stateParams.zoomDepth,
    },
  };

  return {
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    internalState,
  };
}
